import {Component} from '@angular/core';
/**
 * \@title Basic buttons
 */
export class ButtonOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'button-overview-example',
  templateUrl: 'button-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ButtonOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
ButtonOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
